jQuery(document).on('turbolinks:load', function() {
  // Prevent double initilisation. With turbolinks 5 this function
  // will be called twice: on 'ready' and 'turbolinks:load'
  jQuery(document).off('ready page:load')
  MicroModal.init();
});

jQuery(document).on('ready page:load', function() {
  MicroModal.init();
});